var DomainException = require('../DomainException');
const AggregateRoot = require('../ddd/AggregateRoot');
const { newGuid } = require('../../utils');
const _ = require('../../lodash');
const getConstants = require('../../utils/getConstants');
const constants = getConstants();

const { locationAssignmentTypes, dataIntentFlags } = constants;
class DataSource extends AggregateRoot {
   constructor({ user, logger, sequenceProvider }) {
      super({ user, logger });

      this.sequenceProvider = sequenceProvider;
   }

   get agt() {
      return 'DataSource';
   }

   async initNew({ name }) {
      const tid = this.domainUser.tid;

      let noDataSource = await this.sequenceProvider.getNextDataSourceNo({ tid });

      let p = {
         aid: newGuid(),
         noDataSource,
         name,

         partitions: [
            {
               no: 0,
               intent: dataIntentFlags.CATALOG,
               rows: [],
               where: {
                  noLocationAssignmentType: locationAssignmentTypes.ALL_LOCATIONS.id,
                  all: true,
                  specific: [],
                  at: [],
                  within: [],
                  atTaggedAs: null
               }
            }
         ],
         tid
      };

      this.apply('DATASOURCE_ADDED', p);

      var o = _.omit(p, ['aid', 'tid']);

      this.setData(
         {
            properties: _.merge(
               {
                  id: p.aid
               },
               o
            )
         },
         true
      );
   }

   update({ name }) {
      const before = _.pick(this._properties, ['name']);

      var p = { after: { name }, before, noDataSource: this._properties.noDataSource };

      if (p.after.name === before.name) {
         // nothing to do
         return;
      }

      this.apply('DATASOURCE_UPDATED', p);

      this._properties.name = p.after.name;
   }

   isExistingPartition(partition) {
      let idx = _.findIndex(this._properties.partitions, (part) => {
         return part.no === partition.no;
      });
      return idx > -1;
   }

   addPartition(partition) {
      const intent = typeof partition.intent === 'number' ? partition.intent : dataIntentFlags.CATALOG;

      var p = {
         noDataSource: this._properties.noDataSource,
         no: partition.no,
         intent,
         rows: [],

         noLocationAssignmentType: locationAssignmentTypes.UNASSIGNED.id
      };

      this.apply('DATASOURCE_PARTITION_ADDED', p);

      let where = {
         noLocationAssignmentType: locationAssignmentTypes.UNASSIGNED.id,
         all: false,
         specific: [],
         at: [],
         within: [],
         atTaggedAs: null
      };

      this._properties.partitions.push({ no: partition.no, intent, rows: [], where });
   }

   assignPartitionToAllLocations({ noPartition }) {
      const existing = this.ensureExistingPartition(noPartition);

      if (existing.where.all) {
         return;
      } // already marked as all

      var p = {
         noLocationAssignmentType: locationAssignmentTypes.ALL_LOCATIONS.id,
         noDataSource: this._properties.noDataSource,
         no: noPartition
      };

      this.apply('DATASOURCE_PARTITION_ASSIGNED_ALLLOCATIONS', p);

      let where = existing.where;

      where.noLocationAssignmentType = p.noLocationAssignmentType;
      where.all = true;
      where.specific = [];
      where.at = [];
      where.within = [];
      where.atTaggedAs = null;
   }

   assignPartitionToSpecificLocations({ noPartition, nosLocation }) {
      const existing = this.ensureExistingPartition(noPartition);

      var p = {
         nosLocation,
         noLocationAssignmentType: locationAssignmentTypes.SPECIFIC_LOCATION.id,
         noDataSource: this._properties.noDataSource,
         no: noPartition
      };

      this.apply('DATASOURCE_PARTITION_ASSIGNED_SPECIFIC_LOCATIONS', p);

      let where = existing.where;

      where.noLocationAssignmentType = p.noLocationAssignmentType;
      where.all = false;
      where.specific = _.map(nosLocation, (l) => {
         return { no: l };
      });
      where.at = [];
      where.within = [];
      where.atTaggedAs = null;
   }

   assignPartitionToWorkAtLocations({ noPartition, nosLocation }) {
      const existing = this.ensureExistingPartition(noPartition);

      var p = {
         nosLocation,
         noLocationAssignmentType: locationAssignmentTypes.AT_LOCATION.id,
         noDataSource: this._properties.noDataSource,
         no: noPartition
      };

      this.apply('DATASOURCE_PARTITION_ASSIGNED_WORKAT_LOCATIONS', p);

      let where = existing.where;

      where.noLocationAssignmentType = p.noLocationAssignmentType;
      where.all = false;
      where.specific = [];
      where.at = _.map(nosLocation, (l) => {
         return { no: l };
      });
      where.within = [];
      where.atTaggedAs = null;
   }

   assignPartitionWithinLocations({ noPartition, nosLocation }) {
      const existing = this.ensureExistingPartition(noPartition);

      var p = {
         nosLocation,
         noLocationAssignmentType: locationAssignmentTypes.WITHIN.id,
         noDataSource: this._properties.noDataSource,
         no: noPartition
      };

      this.apply('DATASOURCE_PARTITION_ASSIGNED_WITHIN_LOCATIONS', p);

      let where = existing.where;

      where.noLocationAssignmentType = p.noLocationAssignmentType;
      where.all = false;
      where.specific = [];
      where.at = [];
      where.within = _.map(nosLocation, (l) => {
         return { no: l };
      });
      where.atTaggedAs = null;
   }

   assignPartitionAtLocationsTaggedAs({ noPartition, noTag }) {
      const existing = this.ensureExistingPartition(noPartition);

      var p = {
         noTag,
         noLocationAssignmentType: locationAssignmentTypes.AT_TAGGED_WITH.id,
         noDataSource: this._properties.noDataSource,
         no: noPartition
      };

      this.apply('DATASOURCE_PARTITION_ASSIGNED_ATLOCATIONS_TAGGEDAS', p);

      let where = existing.where;

      where.noLocationAssignmentType = p.noLocationAssignmentType;
      where.all = false;
      where.specific = [];
      where.at = [];
      where.within = [];
      where.atTaggedAs = { noTag };
   }

   unassignParitionFromEveryLocation({ noPartition }) {
      const existing = this.ensureExistingPartition(noPartition);

      var p = {
         noLocationAssignmentType: locationAssignmentTypes.UNASSIGNED.id,
         noDataSource: this._properties.noDataSource,
         no: noPartition
      };

      this.apply('DATASOURCE_PARTITION_UNASSIGNED_FROMEVERY_LOCATION', p);

      let where = existing.where;

      where.noLocationAssignmentType = p.noLocationAssignmentType;
      where.all = false;
      where.specific = [];
      where.at = [];
      where.within = [];
      where.atTaggedAs = null;
   }

   ensureExistingPartition(noPartition, message) {
      message = message || 'A partition with that no doesnt exist.';

      var sl = _.find(this._properties.partitions, (x) => {
         return x.no === noPartition;
      });

      if (!sl) {
         throw new DomainException(message);
      }

      return sl;
   }

   updatePartitionRows({ noPartition, rows }) {
      const existing = this.ensureExistingPartition(noPartition);

      this.updatePartition({ currentPartition: existing, updatedRows: rows });
   }

   updatePartition({ currentPartition, updatedRows }) {
      let currentActiveRows = _.filter(currentPartition.rows, (cr) => {
         return !cr.deleted;
      });

      // Determine deletes
      let rowsToDelete = _.filter(currentActiveRows, (cr) => {
         const updatedRow = _.find(updatedRows, (ur) => ur.id == cr.id);
         return !updatedRow || updatedRow.deleted === true;
      });

      // Determine adds
      let rowsToAdd = _.filter(updatedRows, (ur) => {
         const exists = _.find(currentPartition.rows, (cr) => ur.id == cr.id);
         return !exists && ur.deleted !== true;
      });

      // Determine updates
      let rowsToUpdate = _.filter(updatedRows, (ur) => {
         const idx = _.findIndex(currentPartition.rows, (cr) => ur.id == cr.id);
         if (idx === -1 || ur.deleted) return false;

         const currentRow = currentPartition.rows[idx];
         const normalized = _.defaultsDeep({ deleted: false }, ur);
         return !_.isEqual(currentRow, normalized);
      });

      if (rowsToDelete.length > 0) {
         this.deleteRows({ currentPartition, rowsToDelete: _.cloneDeep(rowsToDelete) });
      }

      if (rowsToAdd.length > 0) {
         this.addRows({ currentPartition, rowsToAdd: _.cloneDeep(rowsToAdd) });
      }

      if (rowsToUpdate.length > 0) {
         this.updateRows({ currentPartition, rowsToUpdate: _.cloneDeep(rowsToUpdate) });
      }
   }

   addRows({ currentPartition, rowsToAdd }) {
      var p = { rowsToAdd, noDataSource: this._properties.noDataSource, noDataSourcePartition: currentPartition.no };

      this.apply('DATASOURCE_ROWS_ADDED', p);

      _.each(rowsToAdd, (cr) => {
         cr.deleted = false;
         currentPartition.rows.push(cr);
      });
   }

   updateRows({ currentPartition, rowsToUpdate }) {
      var p = { rowsToUpdate };

      this.apply('DATASOURCE_ROWS_UPDATED', p);

      _.each(currentPartition.rows, (cr) => {
         const idx = _.findIndex(rowsToUpdate, (ur) => {
            return ur.id == cr.id;
         });
         if (idx > -1) {
            _.merge(cr, rowsToUpdate[idx]);
            cr.deleted = false;
         }
      });
   }

   deleteRows({ currentPartition, rowsToDelete }) {
      var p = { rowsToDelete };

      this.apply('DATASOURCE_ROWS_DELETED', p);

      _.each(currentPartition.rows, (cr) => {
         if (
            _.findIndex(rowsToDelete, (dr) => {
               return dr.id == cr.id;
            }) > -1
         ) {
            cr.deleted = true;
         }
      });
   }

   /* ============================================================
    * ✅ NEW: Partition resolver for WRITEBACK partitions
    * ============================================================ */

   getPartitionIntent(partition) {
      return partition && typeof partition.intent === 'number' ? partition.intent : 0;
   }

   isWritebackPartition(partition) {
      return (this.getPartitionIntent(partition) & dataIntentFlags.WRITEBACK) === dataIntentFlags.WRITEBACK;
   }

   matchesAllLocations(partition) {
      if (!partition || !partition.where) return false;
      return partition.where.all === true || partition.where.noLocationAssignmentType === locationAssignmentTypes.ALL_LOCATIONS.id;
   }

   matchesSpecificLocation(partition, noLocation) {
      if (!partition || !partition.where) return false;
      if (partition.where.noLocationAssignmentType !== locationAssignmentTypes.SPECIFIC_LOCATION.id) return false;
      const list = partition.where.specific || [];
      return _.findIndex(list, (x) => x && x.no === noLocation) > -1;
   }

   // Existing helper (kept, slightly corrected)
   getNextPartitionNo() {
      const parts = this._properties.partitions || [];
      if (parts.length === 0) return 0;
      const maxNo = _.max(_.map(parts, (p) => p.no));
      return maxNo == null ? 0 : maxNo + 1;
   }

   ensureWritebackAllLocationsPartition() {
      const parts = this._properties.partitions || [];

      const existing = _.find(parts, (p) => this.isWritebackPartition(p) && this.matchesAllLocations(p));
      if (existing) return existing.no;

      const noPartition = this.getNextPartitionNo();
      this.addPartition({ no: noPartition, intent: dataIntentFlags.WRITEBACK });
      this.assignPartitionToAllLocations({ noPartition });

      return noPartition;
   }

   ensureWritebackSpecificLocationPartition({ noLocation }) {
      const parts = this._properties.partitions || [];

      // ✅ Prefer SPECIFIC_LOCATION over everything else
      const existing = _.find(parts, (p) => this.isWritebackPartition(p) && this.matchesSpecificLocation(p, noLocation));
      if (existing) return existing.no;

      const noPartition = this.getNextPartitionNo();
      this.addPartition({ no: noPartition, intent: dataIntentFlags.WRITEBACK });
      this.assignPartitionToSpecificLocations({ noPartition, nosLocation: [noLocation] });

      return noPartition;
   }

   resolveWritebackPartition({ writeScope, noLocation }) {
      if (writeScope === 'global') {
         const noPartition = this.ensureWritebackAllLocationsPartition();
         return { noPartition, partition: this.ensureExistingPartition(noPartition), created: false };
      }

      if (writeScope === 'location') {
         if (typeof noLocation !== 'number' || noLocation < 0) {
            throw new DomainException('resolveWritebackPartition requires noLocation for location scope.');
         }
         const noPartition = this.ensureWritebackSpecificLocationPartition({ noLocation });
         return { noPartition, partition: this.ensureExistingPartition(noPartition), created: false };
      }

      throw new DomainException(`Unknown writeScope: ${writeScope}`);
   }

   /* ============================================================
    * ✅ UPDATED: Apply writebacks using resolver
    * ============================================================ */

   /**
    * patches: [{ rowKey, patch: { prep: 5, waste: 2, ... } }]
    */
   applyLocationWriteBacks({ noLocation, patches }) {
      if (!patches || patches.length === 0) return { applied: [], skipped: [] };

      const { partition } = this.resolveWritebackPartition({ writeScope: 'location', noLocation });
      return this.applyPartitionPatches({ currentPartition: partition, patches });
   }

   /**
    * patches: [{ rowKey, patch: { someGlobalCol: 123, ... } }]
    */
   applyGlobalWriteBacks({ patches }) {
      if (!patches || patches.length === 0) return { applied: [], skipped: [] };

      const { partition } = this.resolveWritebackPartition({ writeScope: 'global' });
      return this.applyPartitionPatches({ currentPartition: partition, patches });
   }

   /**
    * Resolve the frozen business identity outside the destination WRITEBACK overlay.
    * Destination-row existence alone must never establish source identity.
    */
   getBusinessRowState({ rowKey, excludePartition = null }) {
      const key = rowKey != null ? rowKey.toString() : null;
      if (!key) return 'missing';

      let hasTombstone = false;
      const partitions = this._properties.partitions || [];

      for (const partition of partitions) {
         if (excludePartition && (partition === excludePartition || partition.no === excludePartition.no)) continue;

         // WRITEBACK partitions are overlays only; they never establish whether the frozen source identity still exists.
         if (this.isWritebackPartition(partition)) continue;

         for (const row of partition.rows || []) {
            if (!row || !row.data || row.data.id == null) continue;
            if (row.data.id.toString() !== key) continue;
            if (!row.deleted) return 'active';
            hasTombstone = true;
         }
      }

      return hasTombstone ? 'tombstoned' : 'missing';
   }

   applyPartitionPatches({ currentPartition, patches }) {
      if (!currentPartition) throw new DomainException('applyPartitionPatches requires currentPartition.');
      if (!patches || patches.length === 0) return { applied: [], skipped: [] };

      // Destination-row absence is not source-row absence. Include tombstones so an existing overlay can be updated
      // without creating a duplicate business identity.
      const byRowKey = {};
      _.each(currentPartition.rows || [], (r) => {
         if (r && r.data && r.data.id != null) {
            byRowKey[r.data.id.toString()] = r;
         }
      });

      const rowsToAdd = [];
      const rowsToUpdate = [];
      const rowsToKeepDeleted = [];
      const applied = [];
      const skipped = [];

      _.each(patches, (p) => {
         const rowKey = p.rowKey != null ? p.rowKey.toString() : null;
         if (!rowKey) return;

         const sourceState = this.getBusinessRowState({ rowKey, excludePartition: currentPartition });
         if (sourceState === 'missing') {
            skipped.push({ rowKey, reason: 'source-business-row-missing' });
            return;
         }

         const patchData = _.cloneDeep(p.patch || {});
         patchData.id = isNaN(Number(rowKey)) ? rowKey : Number(rowKey);

         const existing = byRowKey[rowKey];
         const preserveDeleted = sourceState === 'tombstoned';

         if (!existing) {
            const row = {
               id: newGuid(),
               data: patchData,
               deleted: preserveDeleted
            };
            rowsToAdd.push(row);
            if (preserveDeleted) rowsToKeepDeleted.push({ id: row.id });
            applied.push(rowKey);
            return;
         }

         rowsToUpdate.push({
            id: existing.id,
            data: patchData
         });
         if (preserveDeleted) rowsToKeepDeleted.push({ id: existing.id });
         applied.push(rowKey);
      });

      if (rowsToAdd.length > 0) {
         this.addRows({ currentPartition, rowsToAdd: _.cloneDeep(rowsToAdd) });
      }

      if (rowsToUpdate.length > 0) {
         this.updateRows({ currentPartition, rowsToUpdate: _.cloneDeep(rowsToUpdate) });
      }

      // Generic add/update operations intentionally activate rows. Re-delete only WRITEBACK rows whose historical
      // business identity is tombstoned so both in-memory and persisted state remain deleted.
      if (rowsToKeepDeleted.length > 0) {
         this.deleteRows({ currentPartition, rowsToDelete: rowsToKeepDeleted });
      }

      return { applied, skipped };
   }
}

module.exports = DataSource;
